import { SelectV4 } from '@labrav/react-components'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import aws from '../../common/images/aws.png'
import azure from '../../common/images/azureCloud.png'
import React from 'react'
import { useStyles } from './CombinedFormCloudAccountSelector.styles'
import { type AccountDataSelection as AccountData } from '@labrav/common'
import { CloudType } from '../../types'
import { SelectChangeEvent } from '@mui/material'

interface CombinedFormCloudAccountSelectorProps {
  accounts: AccountData[]
  disabled?: boolean
  cloud: CloudType
  value: string
  keyName: string
  handleChangeSelect: (event: SelectChangeEvent) => void
  error?: boolean
  errorMessage?: string
}

export const CombinedFormCloudAccountSelector = ({
  accounts,
  disabled,
  cloud,
  value,
  keyName = 'labraCpId',
  handleChangeSelect,
  error = false,
  errorMessage,
}: CombinedFormCloudAccountSelectorProps) => {
  const { classes } = useStyles()
  const selectOptions = accounts.map(account => ({
    label: `${account.name} (${account.externalAccountId ? account.externalAccountId : account.id})`,
    value: account.id,
    key: account.id,
    imageUrl: getCloudImg(cloud),
  }))

  return (
    <>
      <div className={classes.root}>
        <div className={classes.selector} data-testid={'account-selector'}>
          <SelectV4
            field={{
              title: 'Your cloud account',
              placeHolder: 'Your cloud account',
              id: keyName,
              isRequired: false,
              humanReadableKey: 'authorization',
              isReadOnly: disabled,
              isCustom: false,
              value: value,
              dataType: 'enum' as DataType,
              options: selectOptions,
              disabled: disabled,
            }}
            onChange={handleChangeSelect}
            isError={error}
            errorText={errorMessage}
            size={'small'}
            value={value}
            minWidth="389px"
          />
        </div>
      </div>
    </>
  )
}

const getCloudImg = (cloud?: CloudType) => {
  if (cloud === CloudType.AWS) {
    return aws
  }
  if (cloud === CloudType.AZURE) {
    return azure
  }
  return ''
}
